import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '../Dialog';

const ConfirmDialog = ({
  open,
  title,
  description,
  buttons,
  onSubmit,
  onClose,
  disableBackdropClick,
  dialogProps,
}) => {
  const intl = useIntl();

  return (
    <Dialog
      open={open}
      onClose={() => onClose('cancel')}
      disableBackdropClick={disableBackdropClick}
      disableEscapeKeyDown={disableBackdropClick}
      {...dialogProps}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {buttons.map(({ translationKey, label, type, response, ...buttonProps }) => (
          <Button
            key={label}
            onClick={() => (type === 'cancel' ? onClose('cancel') : onSubmit(response))}
            {...buttonProps}
          >
            {translationKey
              ? intl.formatMessage({
                  id: translationKey,
                  defaultMessage: label,
                  description: `Confirm dialog button label for ${label}`,
                })
              : label}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
};

ConfirmDialog.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      onClick: PropTypes.func,
      response: PropTypes.string,
    }),
  ),
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
  dialogProps: PropTypes.object,
  disableBackdropClick: PropTypes.bool,
};

ConfirmDialog.defaultProps = {
  open: false,
  title: null,
  description: null,
  buttons: [
    {
      translationKey: 'confirmDialog.defaults.cancel',
      label: 'Cancel',
      type: 'cancel',
      response: 'canceled',
      variant: 'outlined',
    },
    {
      translationKey: 'confirmDialog.defaults.accept',
      label: 'Accept',
      type: 'submit',
      response: 'accepted',
      variant: 'contained',
      color: 'primary',
    },
  ],
  onSubmit: undefined,
  onClose: undefined,
  dialogProps: {},
  disableBackdropClick: false,
};

export default ConfirmDialog;
